<app-input-header *ngIf="outsideLabel && labelValue" [labelKey]="labelValue" [required]="required"></app-input-header>
<mat-form-field
  class="full-width background-white"
  appearance="outline"
  [style.width]="width ?? DEFAULT_WIDTH"
  [ngClass]="{ 'no-outline': !outline, 'input-error': ngControl?.control?.touched && ngControl.control?.errors, 'offers': colors === ColorSchemes.OFFERS }"
>
  <mat-icon matPrefix *ngIf="prefixIcon || searchable">{{ prefixIcon || 'search' }}</mat-icon>
  <mat-label *ngIf="labelValue && !outsideLabel">
    {{ labelValue | locLabel }} <app-required-indicator *ngIf="required"></app-required-indicator>
  </mat-label>

  <mat-select #selectSingle [ngClass]="{ 'offers': colors === ColorSchemes.OFFERS }" [(ngModel)]="value" *ngIf="!multiple" [disabled]="disabled" [panelClass]="'panel-size-' + maxHeight">
    <mat-select-trigger *ngIf="child">
      <ng-template *ngTemplateOutlet="child; context: { data: selectedOption ?? EMPTY_OPTION }"></ng-template>
    </mat-select-trigger>

    <mat-option *ngIf="searchable">
      <ngx-mat-select-search
        [formControl]="searchControl"
        [placeholderLabel]="placeholderKey | locLabel"
        [noEntriesFoundLabel]="noEntriesLabelKey | locLabel"
      ></ngx-mat-select-search>
    </mat-option>

    <ng-content select="[custom-first]" *ngIf="!child"></ng-content>

    <mat-option *ngFor="let option of filteredOptions" [value]="option.value">
      <ng-container *ngIf="!child">
        {{ { key: option.title, modifier: LocLabelModifier.CAP } | locLabel }}
      </ng-container>
      <ng-container *ngIf="child">
        <ng-template *ngTemplateOutlet="child; context: { data: option }"></ng-template>
      </ng-container>
    </mat-option>

    <ng-content *ngIf="!child"></ng-content>
  </mat-select>

  <!-- HACK: [attr.multiple] can't be set dynamically: https://docs.angularjs.org/error/$compile/selmulti-->
  <!-- HACK: using template cause NullInjectorError: R3InjectorError(AppModule)[MatSelect -> MatSelect -> MatSelect]: -->
  <!-- HACK: using template cause NullInjectorError: No provider for MatSelect!-->
  <!-- TODO: Find other solution to avoid code repetition -->

  <mat-select #selectMulti [(ngModel)]="value" *ngIf="multiple" multiple [disabled]="disabled">
    <mat-select-trigger *ngIf="child">
      <ng-template *ngTemplateOutlet="child; context: { data: selectedOption ?? EMPTY_OPTION }"></ng-template>
    </mat-select-trigger>

    <mat-option *ngIf="searchable">
      <ngx-mat-select-search
        [formControl]="searchControl"
        [placeholderLabel]="placeholderKey | locLabel"
        [noEntriesFoundLabel]="noEntriesLabelKey | locLabel"
      ></ngx-mat-select-search>
    </mat-option>

    <!-- HACK: multiple contents with the same select don't work -->
    <ng-content select="[custom-first-multi]" *ngIf="!child"></ng-content>

    <mat-option *ngFor="let option of filteredOptions" [value]="option.value">
      <ng-container *ngIf="!child">
        {{ option.title | locLabel }}
      </ng-container>
      <ng-container *ngIf="child">
        <ng-template *ngTemplateOutlet="child; context: { data: option }"></ng-template>
      </ng-container>
    </mat-option>

    <ng-content *ngIf="!child"></ng-content>
  </mat-select>

  <ng-template #selectContent> </ng-template>
</mat-form-field>
<app-input-footer *ngIf="footer" [control]="ngControl?.control"></app-input-footer>
